import { Navigate } from 'react-router-dom';
import { TelegramLoginButton } from '../components/TelegramLoginButton';
import { useAuth } from '../hooks/useAuth';
import { isTelegramWebApp } from '../utils/telegramWebApp';

export function LoginPage() {
  const { user, loading, config, authError } = useAuth();

  if (loading) {
    return <div className="login-page">Загрузка…</div>;
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  const inTelegram = isTelegramWebApp();

  return (
    <div className="login-page">
      <div className="card login-card">
        <h1>VPN Panel</h1>
        <p className="login-hint">
          {inTelegram
            ? 'Открыто в Telegram — если вход не прошёл автоматически, вы не в списке админов.'
            : 'Войдите через Telegram. Доступ только для администраторов.'}
        </p>

        {!inTelegram && <TelegramLoginButton botUsername={config?.bot_username ?? ''} />}

        {authError && (
          <p style={{ color: 'var(--danger)', marginTop: '1rem', fontSize: '0.875rem' }}>{authError}</p>
        )}
      </div>
    </div>
  );
}
